import TermLink from './TermLink';

export default TermLink;
